import { useEffect, useState } from 'react';

import { getSpeciesById, Species } from '../../../api/fishrules/getSpeciesById';
import { reportMykissClientError } from '@lib/errors/client';

interface Result {
  isLoading: boolean;
  species?: Species;
}

interface Params {
  fishrulesSpeciesId: number;
}

export function useSpeciesById(params: Params): Result {
  const [isLoading, setIsLoading] = useState(true);
  const [species, setSpecies] = useState<Species>();

  const fishrulesSpeciesId = params.fishrulesSpeciesId;

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);

    getSpeciesById({ fishrulesSpeciesId }, controller.signal)
      .then(({ results, success, message }) => {
        if (success && results.length) {
          setSpecies(results[0]);
        } else {
          setSpecies(undefined);
        }
        setIsLoading(false);
        if (!success && message) {
          reportMykissClientError(new Error(message));
        }
      })
      .catch((error: unknown) => {
        if (error instanceof Error && error.name !== 'AbortError') {
          reportMykissClientError(error);
        }
        setIsLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, [fishrulesSpeciesId]);

  return { isLoading, species };
}
